import { render } from "./company-personnel-perfo.vue?vue&type=template&id=78ad9bba&scoped=true"
import script from "./company-personnel-perfo.vue?vue&type=script&lang=js"
export * from "./company-personnel-perfo.vue?vue&type=script&lang=js"

import "./company-personnel-perfo.vue?vue&type=style&index=0&id=78ad9bba&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ad9bba"]])

export default __exports__